<script lang="ts">
  import { onMount } from 'svelte';

  let loadingFailed = false;

  const mountLoginComponent = async () => {
    try {
      // Import the module federation login component
      // @ts-ignore - module federation component loaded at runtime
      import('App/GrappleAuth/login').then((m) => {
        let module = m.default;
        new module({
          target: document.getElementById('login'),
          layout: 'auto',
        });
      });
    } catch (error) {
      console.error(
        'Failed to load login component from module federation:',
        error,
      );
      loadingFailed = true;
    }
  };

  onMount(async () => {
    mountLoginComponent();
  });

  // Add redirect URL parameter for successful login
  if (typeof window !== 'undefined') {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('redirectUrl', '/admin');
    if (!currentUrl.searchParams.has('redirectUrl')) {
      window.history.replaceState({}, '', currentUrl.toString());
    }
  }
</script>

{#if !loadingFailed}
  <div id="login"></div>
{:else if loadingFailed}
  <!-- Error state if module federation component failed to load -->
  <div class="flex min-h-full flex-col bg-white pt-16 pb-12">
    <main
      class="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8"
    >
      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div class="flex justify-center">
            <div
              class="flex h-12 w-12 items-center justify-center rounded-full bg-red-100"
            >
              <svg
                class="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
          </div>
          <p class="mt-4 text-center font-medium text-gray-800">
            Authentication service unavailable
          </p>
          <p class="mt-2 text-center text-sm text-gray-600">
            Please try refreshing the page or contact support.
          </p>
        </div>
      </div>
    </main>
  </div>
{:else}
  <!-- Loading state while the component is being loaded -->
  <div class="flex min-h-full flex-col bg-white pt-16 pb-12">
    <main
      class="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8"
    >
      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div class="flex justify-center">
            <div
              class="h-12 w-12 animate-spin rounded-full border-b-2 border-indigo-600"
            ></div>
          </div>
          <p class="mt-4 text-center text-gray-600">
            Loading authentication...
          </p>
        </div>
      </div>
    </main>
  </div>
{/if}
